import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
const styles = theme => ({});
const reasons = ["Transaction Error"];
let _this;
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

class ContactForm extends React.Component {
  state = {
    name: "",
    message: "",
    email: "",
    trans_id: "",
    reason: ""
  };
  constructor() {

    super();
    _this = this;
  }
  clearFields(){
    _this.setState({
      name: "",
      message: "",
      email: "",
      trans_id: "",
      phone:"",
      reason: ""
    });
  }
  handleChange = name => event => {
    event.preventDefault();

    _this.setState({ [name]: event.target.value });
  };
  render() {
    const { classes } = this.props;
    const { name,message,email,trans_id,reason,phone } = this.state;
    return (
      <Grid container className={classes.container} style={{maxWidth:'720px',margin:'auto'}} >
        <Grid item xs={12} >
        <TextField
          value={name}
          className={classes.textField}
          placeholder="Name"
          fullWidth
          type="text"
          margin="normal"
          variant="outlined"
          onChange={this.handleChange("name")}
        />
      </Grid>
      <Grid item xs={12} >
      <TextField
        value={email}
        className={classes.textField}
        placeholder="Enter email"
        fullWidth
        type="email"
        margin="normal"
        variant="outlined"
        onChange={this.handleChange("email")}
      />
    </Grid>
    <Grid item xs={12} >
    <TextField
      value={phone}
      className={classes.textField}
      placeholder="Enter your phone (include country code: +1 222 333 4444)"
      fullWidth
      type="text"
      margin="normal"
      variant="outlined"
      onChange={this.handleChange("phone")}
    />
  </Grid>
    <Grid item xs={12} >
    <TextField
      value={trans_id}
      className={classes.textField}
      placeholder="Transaction Id (Optional): 8B761281LX296814K"
      fullWidth
      type="text"
      margin="normal"
      variant="outlined"
      onChange={this.handleChange("trans_id")}
    />
  </Grid>
  <Grid item xs={12} >
  <TextField
    value={message}
    className={classes.textField}
    placeholder="Message"
    fullWidth
    type="text"
    margin="normal"
    variant="outlined"
    multiline={true}
    rows={3}
    rowsMax={6}
    onChange={this.handleChange("message")}
  />
</Grid>
<Grid item xs={12} >
<Grid container justify="center" spacing={Number(16)}>
  <Grid item>
    <Button variant="contained" disabled={name.trim().length==0||!validateEmail(email)||(!phone||phone.trim().length==0)||message.trim().length==0} onClick={()=>this.props.OnSubmit({message,name,reason,trans_id,email,phone})} color="secondary" size="large">
      SEND
    </Button>
  </Grid>
</Grid>
</Grid>
        </Grid>

    );
  }
}

ContactForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ContactForm);
